<template>
    <div style="height: 100%;margin-top: 54px;">
        <spinner :data="spinnerData"></spinner>
        <div v-if="hasLiveMatch" class="main-header" style="margin: 4px auto;padding: 20px">
            <div class="liveScoresBox" v-for="(feed, index) in liveFeed" :key="index">
                <router-link :to="{name: 'LivescoresMatch', params: {match_id: feed.match_key} }">
                    <div @click="getSelectedMatch(feed)" class="versus">
                        <div class="match_options">
                            <span class="timing" v-html="feed.match_date"></span>
                            <span class="league" v-html="feed.league_name"></span>
                            <span class="status" :style=" feed.match_live === '1' ? 'color: #00E56B' : '' "> {{ feed.match_live === '0' ? 'Upcoming' : 'Live' }} </span>
                        </div>
                        <div class="container">
                            <div class="row" style="border:solid 1px transparent;">
                                <div class="col col-4">
                                    <div v-if="feed.home_team_badge === '' || feed.home_team_badge === 'undefined' " class="versus-img"></div>
                                    <div v-else class="versus-img">
                                        <img :src="feed.home_team_badge" />
                                    </div>
                                    <p v-html="feed.home_team_name"></p>
                                </div>
                                <div class="col col-4">
                                    <div class="caption">
                                        <p>( {{ feed.hometeam_score }} - {{feed.awayteam_score}} )</p>
                                        <h1>VS</h1>
                                    </div>
                                </div>
                                <div class="col col-4">
                                    <div v-if="feed.away_team_badge === '' || feed.away_team_badge === 'undefined' " class="versus-img"></div>
                                    <div class="versus-img">
                                        <img :src="feed.away_team_badge" />
                                    </div>
                                    <p v-html="feed.away_team_name"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>

        </div>

        <div style="width: 100%;padding: 20px;">
            <div v-if="hasLiveMatch === false" class="space"></div>
            <div v-if="feedsStatus">
                <div class="liveScoresBox" v-for="(feed, index) in feeds" :key="index">
                    <router-link :to="{name: 'Match', params: {fixture_id: feed.match_key} }">
                        <div @click="getSelectedMatch(feed)" class="versus">
                            <div class="match_options">
                                <span class="timing" v-html="feed.match_date"></span>
                                <span class="league" v-html="feed.league_name"></span>
                                <span class="status" :style=" feed.match_live === '1' ? 'color: #00E56B' : '' "> {{ feed.match_live === '0' ? 'Upcoming' : 'Live' }} </span>
                            </div>
                            <div class="container">
                                <div class="row" style="border:solid 1px transparent;">
                                    <div class="col col-4">
                                        <div v-if="feed.home_team_badge === '' || feed.home_team_badge === 'undefined' " class="versus-img"></div>
                                        <div v-else class="versus-img">
                                            <img :src="feed.home_team_badge" />
                                        </div>
                                        <p v-html="feed.home_team_name"></p>
                                    </div>
                                    <div class="col col-4">
                                        <div class="caption">
                                            <p>( {{ feed.hometeam_score }} - {{feed.awayteam_score}} )</p>
                                            <h1>VS</h1>
                                        </div>
                                    </div>
                                    <div class="col col-4">
                                        <div v-if="feed.away_team_badge === '' || feed.away_team_badge === 'undefined' " class="versus-img"></div>
                                        <div class="versus-img">
                                            <img :src="feed.away_team_badge" />
                                        </div>
                                        <p v-html="feed.away_team_name"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>

            </div>
            <div v-else class="ui-block">
                <div
                        class="ui-block-content text-center"
                        style="padding: 50px 23px; border-top:solid 4px #08ddc1"
                >
                    <h4 class="title" style="font-weight:bold;color:#fff">Opps! No match playing today</h4>
                    <p style="color: #eee">Do check back again thanks.</p>
                    <button @click="openWhatMatch()" class="btn bg-mdd-2-outline btn-rounded" style="">Check for Matches</button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                feedsStatus: Boolean,
                feeds: {},
                liveFeed: {},
                allLeagues: {
                    next_page_url: '',
                    last_page_url: '',
                    first_page_url: '',
                    data: [],
                    total: '',
                },
                spinnerData: {},
                home_logo: "",
                away_logo: "",
                home_team_name: "",
                away_team_name: "",
                hasLiveMatch: false,
                next_page_url: '',
                last_page_url: '',
                first_page_url: '',
                current_page: '',
                last_page: '',
            }
        },
        mounted() {
            this.showLoading();
            this.getAllMatches();
            this.getLivematches();
        },
        methods: {
            setMatchTime(date,time) {
                const d = new Date();
                const datum = Date.parse(date);
            },
            openWhatMatch() {
                $('#whatMatch').click()
            },
            getSelectedMatch(feed) {
                this.$store.commit('selectedFeed', feed)
            },
            showLoading(options = {}) {
                let loader = this.spinnerData = {
                    spinner: 'Jumper',
                    isLoading: options.show !== undefined ? options.show : true ,
                    color: '#00bfff',
                    size: '60px',
                    options: 'center relative',
                };
                return loader;
            },
            getLivematches() {
                this.axios.get('matches/live/10')
                    .then(res => {
                        const liveStatus = res.data.data.status;
                        if(liveStatus === true) {
                            this.hasLiveMatch = liveStatus;
                            const matches = res.data.data.matches;
                            this.feedsStatus = res.data.data.status;
                            this.next_page_url = matches.next_page_url;
                            this.last_page_url = matches.last_page_url;
                            this.first_page_url = matches.first_page_url;
                            this.liveFeed = matches.data
                        }
                    })
                    .catch(err => {
                        // console.log(err)
                        return err
                    })
            },
            getAllMatches() {
                this.axios.get('matches/today/10')
                .then(res => {
                    this.showLoading({show:false});
                    const matches = res.data.data.matches;
                    this.feedsStatus = res.data.data.status;
                    this.next_page_url = matches.next_page_url;
                    this.last_page_url = matches.last_page_url;
                    this.first_page_url = matches.first_page_url;
                    this.feeds = matches.data

                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
    }
</script>